import { getFirestore, doc, getDoc } from "firebase/firestore";

const getSGIConfig = async (ruc, formatId) => {
  try {
    const db = getFirestore();
    const docRef = doc(db, "headerSGI", ruc, "sgiFormatos", formatId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      throw new Error("Formato SGI no encontrado");
    }

    const data = docSnap.data();
    
    return {
      ...data,
      // Usar directamente el string de fecha sin formateo
      fecha: data.fecha || ''
    };
  } catch (error) {
    console.error("Error obteniendo config SGI:", error);
    throw error;
  }
};

export const createSGIHeader = async (ruc, formatId, company) => {
  try {
    const config = await getSGIConfig(ruc, formatId);

    const styles = `
  <style>
    .sgi-header {
      border-collapse: collapse;
      width: 100%;
      border: 1px solid #000;
      font-family: Arial, sans-serif;
      font-weight: bold;
    }
    .sgi-header td {
      border: none;
    }
    .logo-section {
      width: 20%;
      vertical-align: center;
      border-right: 1px solid #000 !important;
      font-size: 12px;
      font-family: Arial, sans-serif;
    }
    .title-section {
      width: 54%;
      vertical-align: center;
      border-right: 1px solid #000 !important;
      font-size: 14px;
      font-family: Arial, sans-serif;
    }
    .info-section {
      width: 26%;
      vertical-align: center;
      font-size: 12px;
      font-family: Arial, sans-serif;
    }
    .inner-table {
      width: 100%;
      border: none;
      font-family: Arial, sans-serif;
    }
    .inner-table td {
      border: none;
    }
    .title-row:first-child td {
      border-bottom: 1px solid #000;
    }
    .logo-container {
      height: 70px;
      text-align: center;
    }
    .ruc-container {
      padding: 3px;
      font-size: 12px;
      font-weight: bold;
      text-align: center;
    }
    .company-logo {
      max-width: 100px;
      max-height: 60px;
    }
    .title-row {
      text-align: center;
      font-weight: bold;
      padding: 5px;
      height: 50%; /* Asegura que cada fila ocupe la mitad del espacio */
    }
    .title-row td {
      height: 40px; /* Altura fija para ambas filas */
      vertical-align: middle; /* Centra el texto verticalmente */
      display: table-cell;
    }
    .info-row {
      height: 14px;
    }
    .info-label {
      width: 35%;
      padding: 2px;
      font-weight: bold;
      text-align: left;
    }
    .info-value {
      width: 65%;
      padding-top: 2px;
      padding-bottom: 2px;
      padding-right: 2px;
      font-weight: bold;
      text-align: left;
    }
  </style>
`;

    return `
    ${styles}
    <table class="sgi-header">
      <tbody>
        <tr style="height: 100px;">
          <td class="logo-section">
            <table class="inner-table">
              <tbody>
                <tr>
                  <td class="logo-container">
                  ${company.logo ? `<img src="${company.logo}" alt="Logo" class="company-logo">` : ''}
                </td>
                </tr>
                <tr>
                  <td class="ruc-container">RUC: ${ruc}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td class="title-section">
            <table class="inner-table">
              <tbody>
                <tr class="title-row">
                  <td>${company.nombreComercial || ''}</td>
                </tr>
                <tr class="title-row">
                  <td>${config.titulo || ''}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td class="info-section">
            <table class="inner-table">
              <tbody>
                <tr class="info-row">
                  <td class="info-label">Código</td>
                  <td class="info-value">${config.codigo || ''}</td>
                </tr>
                <tr class="info-row">
                  <td class="info-label">Versión</td>
                  <td class="info-value">${config.version || ''}</td>
                </tr>
                <tr class="info-row">
                  <td class="info-label">Fecha</td>
                  <td class="info-value">${config.fecha || ''}</td>
                </tr>
                <tr class="info-row">
                  <td class="info-label">Páginas</td>
                  <td class="info-value">${config.paginas || ''}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  `;
  } catch (error) {
    console.error("Error generando encabezado SGI:", error);
    throw error;
  }
};

/*Base de Datos
headerSGI/
  ├─ [RUC]/
  │   ├─ sgiFormatos/
  │   │   ├─ 10/
  │   │   │   ├─ titulo: "Reporte de Asistencia"
  │   │   │   ├─ codigo: "SGI-RH-FOR-001"
  │   │   │   ├─ version: "01"
  │   │   │   ├─ paginas: "1 de 1"
*/